module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('pie-chart', {
    attrs: {
      "data": _vm.chart,
      "donut": false,
      "thousands": ",",
      "suffix": "%",
      "colors": _vm.colours,
      "legend": "left"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70544ab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/charts/SharersChart.vue
// module id = 1635
// module chunks = 0